import React from 'react';
import K from '../constants';
import { CreditCardOutlinedIcon, WalletOutlinedIcon, SavingsIcon } from '../common/icons';
import { isAndroid } from 'react-device-detect';
import { message } from 'antd';
import { getCustomerConfig } from './customerHelper';

const MESSAGE_CONFIG = {
  top: 100,
  duration: 3,
  maxCount: 3
};

const manageableVehicleLabel = ({ translationsStore, vehicle }) => {
  let label = `${translationsStore.translate('common.plate')}: ${vehicle.license_plate}`;
  if (vehicle.hasOwnProperty('brand') && vehicle.hasOwnProperty('model')) {
    label = `${vehicle.brand.name} ${vehicle.model.name} - ${label}`;
  }
  return label;
};

const paymentIcon = (payment) => {
  const key = payment.hasOwnProperty('key') ? payment.key : payment;
  switch (key) {
    case 'creditcard':
      return <CreditCardOutlinedIcon />;
    case 'sepa':
      return <SavingsIcon />
    default:
      return <WalletOutlinedIcon />;
  }
};

const handleDeepLink = (path = '/') => {
  const config = getCustomerConfig();
  const deeplink = config.deeplink || {};

  // Fallback to env variables if not specified in customer config
  const androidIntentPackage = deeplink.androidIntentPackage || K.ANDROID_INTENT_PACKAGE;
  const iosDeeplinkDestination = deeplink.iosDeeplinkDestination || K.IOS_DEEPLINK_DESTINATION;

  // Build the complete URI from the customer config
  const uri = iosDeeplinkDestination || 'myair://app.myair.io/';
  const scheme = uri.substr(0, uri.indexOf(':'));
  const baseUrl = uri.substr(uri.indexOf('://') + 3).replace(/\/$/, ''); // Remove trailing slash
  const fullPath = path.startsWith('/') ? path : `/${path}`;
  
  let destination = undefined;
  if (isAndroid) {
    destination = `intent://${baseUrl}${fullPath}#Intent;${scheme ? `scheme=${scheme};` : ''}package=${androidIntentPackage};end;`;
  } else {
    destination = `${scheme}://${baseUrl}${fullPath}`;
  }
  window.location = destination;
};

const appMessageError = (str, cb = () => {}) => {
  message.error(str, function() {
    cb();
  });
};

const getOperationalAddress = (installer) => {
  let address = (installer.addresses.find((address) => address.type === 'operational_office') || {}).node;
  if (!address) {
    address = (installer.addresses.find((address) => address.type === 'registered_office') || {}).node;
  }
  return address || {};
};

export default { manageableVehicleLabel, paymentIcon, handleDeepLink, getOperationalAddress, appMessageError, MESSAGE_CONFIG };
